function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "15",
  cy: "15",
  r: "14",
  fill: "#39C360",
  stroke: "#fff",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 16l3 3 7-7",
  stroke: "#fff",
  strokeWidth: "3",
  strokeLinecap: "round"
})));